import React, { useState } from 'react';


export default function AccountHome(props) {

  let dpLogo = require("images/logos/datapulse-logo-blue-small.png");
  dpLogo = <img className="account-home-logo" src={`/datapulse${dpLogo}`} />

  let chat= require("images/lite/icons/chat.png");
  chat = <img src={`/datapulse${chat}`} />

  return (
    <div className="lite-account-home-container">
      <div className="lite-account-home-header">
        <h1>Welcome to {dpLogo}</h1>
        <p className="subheader">Looks like you don't have access yet!</p>
      </div>
      <div className="lite-account-home-content">
        <div>{chat}</div>
        <p>Reach out to your Digital Position account lead for help. They will be able to grant you the permissions you need to access your account.</p>
      </div>
      <div className="lite-account-home-footer">
       <a href="mailto:support@digitalposition.com" >Contact support</a>
      </div>
    </div>
  )
}